import { AppError } from './app-error.model';
export class NotFoundError extends AppError {

}
